import React, { useMemo } from 'react';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { useHistory } from 'react-router-dom';
import styles from '@/pages/decedent-list/styles.less';
import DataGridTable from '@/common/components/DataGridTable/index';
import { AddDecedent } from '@/common/containers/Modals/index';
import { useToggle } from '@/common/hooks/index';
import { routes } from '@/app/routing/index';
import { useTranslation } from 'react-i18next';
import { getDecedentListColumns } from '@/pages/decedent-list/config';
import { getAdminDecedents } from '@/entities/admin-decedents/admin-decedents.api';

const DecedentList = () => {
  const [modal, toggleModal] = useToggle(false);
  const history = useHistory();
  const { t } = useTranslation();
  const columns = useMemo(() => getDecedentListColumns(t), [t]);

  return (
    <>
      {modal && <AddDecedent onClose={toggleModal} open />}
      <section className={styles.page}>
        <div className={styles.pageHeader}>
          <h2>{t('Decedent accounts')}</h2>
          <Button onClick={toggleModal} variant="contained" color="success">
            <AddIcon /> {t('Add decedent account')}
          </Button>
        </div>
        <div className={styles.tableContainer}>
          <DataGridTable
            columns={columns}
            queryFn={getAdminDecedents}
            queryKey={['decedents']}
            onRowClick={({ id }) =>
              history.push(`${routes.adminPanel.decedentProfile}${id}`)
            }
          />
        </div>
      </section>
    </>
  );
};

export default DecedentList;
